import { render, staticRenderFns } from "./BerlianTerjualView.vue?vue&type=template&id=806311d6&"
import script from "./BerlianTerjualView.vue?vue&type=script&lang=js&"
export * from "./BerlianTerjualView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports